<script lang="ts">
  import * as AlertDialog from "$lib/components/ui/alert-dialog/index.js";
  import { hubStore } from "$src/application/realtime/hubStore";
  import {
    requestTakeOverTimerValue,
    requestTakeOverVisible,
    takeOverRequest,
  } from "$src/application/realtime/draftStore";
  import { get } from "svelte/store";
  import { t } from "svelte-i18n";

  function acceptRequest() {
    var request = get(takeOverRequest);
    if( request )
    {
        get(hubStore)?.allowTakingOverProject(request);
    }
  }

  function denyRequest() {
    var request = get(takeOverRequest);
    if( request )
    {
        get(hubStore)?.denyTakingOverProject(request);
    }
  }

</script>


{#if $takeOverRequest}
  <AlertDialog.Root bind:open={$requestTakeOverVisible}>
    <AlertDialog.Content>
      <AlertDialog.Header>
        <AlertDialog.Title>
          {$t('page.projects.draft.takeOverTitle')}
        </AlertDialog.Title>
        <AlertDialog.Description>
          <div class="flex flex-col gap-2">
            <div>
              <span class="inline-block w-2 h-2 bg-green-500 rounded-full" />
              <div class="font-medium gap-2 items-center inline">
                {$takeOverRequest.user.firstname}
                {$takeOverRequest.user.lastname}
              </div>
              {$t('page.projects.draft.takeOverRequestLongText',  {
                values: { requestTakeOverTimerValue: $requestTakeOverTimerValue },
              })}
            </div>
          </div>
        </AlertDialog.Description>
      </AlertDialog.Header>
      <AlertDialog.Footer>
        <AlertDialog.Action on:click={acceptRequest}>
            {$t('page.projects.draft.accept',  {
              values: { requestTakeOverTimerValue: $requestTakeOverTimerValue },
            })}
        </AlertDialog.Action>
        <AlertDialog.Cancel on:click={denyRequest}>
            {$t('page.projects.draft.refuse')}
        </AlertDialog.Cancel>
      </AlertDialog.Footer>
    </AlertDialog.Content>
  </AlertDialog.Root>
{/if}
